import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal right fade",
  id: "myModal2",
  tabindex: "-1",
  "aria-labelledby": "myModalLabel2",
  "data-bs-keyboard": "false",
  "data-bs-backdrop": "static",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  id: "myModalLabel2",
  style: {"background-color":"#0054a6","color":"white"}
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "body" }
const _hoisted_9 = { class: "customSettingName" }
const _hoisted_10 = {
  for: "basic-url",
  style: {"font-size":"16px"}
}
const _hoisted_11 = { class: "input-group mb-3" }
const _hoisted_12 = { class: "counter" }
const _hoisted_13 = { class: "tktTex" }
const _hoisted_14 = {
  for: "basic-url",
  style: {"font-size":"16px"}
}
const _hoisted_15 = { class: "input-group mb-3" }
const _hoisted_16 = { class: "form-check form-check-inline" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  class: "form-check-label",
  for: "inlineRadio1"
}
const _hoisted_19 = { class: "form-check form-check-inline" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  class: "form-check-label",
  for: "inlineRadio2"
}
const _hoisted_22 = { class: "allowance" }
const _hoisted_23 = {
  class: "form-check-label",
  for: "customRange3",
  style: {"font-size":"16px"}
}
const _hoisted_24 = { style: {"position":"absolute","right":"20px"} }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 0,
  class: "defaultSetting mt-3"
}
const _hoisted_27 = { class: "form-check form-check-inline" }
const _hoisted_28 = {
  class: "form-check-label",
  for: "inlineCheckBox3"
}
const _hoisted_29 = {
  class: "buttons",
  style: {"margin-top":"10px"}
}
const _hoisted_30 = {
  for: "basic-url",
  style: {"font-size":"16px"}
}
const _hoisted_31 = { class: "search stitchTypeRow" }
const _hoisted_32 = { class: "stitchType" }
const _hoisted_33 = {
  key: 1,
  class: "lastChanged"
}
const _hoisted_34 = {
  key: 2,
  class: "stitchComponent"
}
const _hoisted_35 = { class: "leftComponent" }
const _hoisted_36 = {
  style: {"border-spacing":"7px 0px","table-layout":"auto","border-collapse":"separate","width":"100%"},
  "aria-hidden": "true"
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 0,
  style: {"font-size":"14px","text-align":"start","white-space":"nowrap"},
  for: "stitchRate"
}
const _hoisted_39 = {
  key: 1,
  style: {"font-size":"14px","text-align":"start","white-space":"nowrap"},
  for: "stitchRate"
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = {
  key: 0,
  style: {"font-size":"14px","text-align":"start","white-space":"nowrap"},
  for: "seamThickness"
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "rightComponent" }
const _hoisted_47 = {
  style: {"border-collapse":"separate","border-spacing":"7px 0px"},
  "aria-hidden": "true"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 0,
  style: {"text-align":"start","font-size":"14px"},
  for: "bight"
}
const _hoisted_50 = {
  key: 1,
  style: {"text-align":"start","font-size":"14px"},
  for: "bight"
}
const _hoisted_51 = { style: {"padding":"0"} }
const _hoisted_52 = {
  style: {"text-align":"start","font-size":"14px"},
  for: "defaultWaste"
}
const _hoisted_53 = { key: 0 }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { style: {"padding":"0"} }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = {
  key: 3,
  style: {"width":"100%","text-align":"left","margin-left":"0"}
}
const _hoisted_58 = {
  key: 4,
  class: "consumption"
}
const _hoisted_59 = { class: "consumptionTable mt-4" }
const _hoisted_60 = { scope: "col" }
const _hoisted_61 = {
  scope: "col",
  class: "num"
}
const _hoisted_62 = {
  scope: "col",
  class: "num"
}
const _hoisted_63 = {
  scope: "col",
  class: "num right"
}
const _hoisted_64 = { class: "component" }
const _hoisted_65 = { class: "num" }
const _hoisted_66 = ["onUpdate:modelValue", "disabled", "id", "aria-label"]
const _hoisted_67 = { class: "unit" }
const _hoisted_68 = { class: "num" }
const _hoisted_69 = { class: "strongValue" }
const _hoisted_70 = {
  key: 0,
  class: "allowanceNote"
}
const _hoisted_71 = { class: "num right strongValue" }
const _hoisted_72 = { class: "component" }
const _hoisted_73 = { class: "num" }
const _hoisted_74 = { class: "num" }
const _hoisted_75 = { class: "num right" }
const _hoisted_76 = { class: "consumptionNote" }
const _hoisted_77 = {
  key: 0,
  class: "allowanceMessage"
}
const _hoisted_78 = {
  style: {"width":"100%"},
  "aria-hidden": "true"
}
const _hoisted_79 = { style: {"float":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertComponent = _resolveComponent("AlertComponent")!
  const _component_ComboBox = _resolveComponent("ComboBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDialogClose && _ctx.handleDialogClose(...args)), ["prevent"]))
          }, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("span", { "aria-hidden": "true" }, [
              _createElementVNode("i", {
                class: "fa fa-times",
                "aria-hidden": "true",
                style: {"background-color":"#0054a6","color":"white"}
              })
            ], -1)
          ]))]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.isCancelButtonClicked)
              ? (_openBlock(), _createBlock(_component_AlertComponent, {
                  key: 0,
                  onSetWindow: _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$emit('visibleEditDialog', false), (_ctx.showEditPopupLocal = false), _ctx.backdropClose()))),
                  isCancelButtonClicked: _ctx.isCancelButtonClicked,
                  onHidePopup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isCancelButtonClicked = false))
                }, null, 8, ["isCancelButtonClicked"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("editCustomSetting.name")), 1),
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "basic-url",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customSettings.name) = $event)),
                    style: {"border-radius":"10px"},
                    "aria-describedby": "basic-addon3",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.customSettings.name]
                  ])
                ]),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.customSettings.name ? _ctx.customSettings.name.length : 0) + "/20", 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("editCustomSetting.tktTex")), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "inlineRadioOptions",
                      id: "inlineRadio1",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customSettings.tktTex) = $event)),
                      value: "Tkt",
                      checked: "",
                      disabled: _ctx.customSettings.name == 'Default'
                    }, null, 8, _hoisted_17), [
                      [_vModelRadio, _ctx.customSettings.tktTex]
                    ]),
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("editCustomSetting.tkt")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "inlineRadioOptions",
                      id: "inlineRadio2",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customSettings.tktTex) = $event)),
                      value: "Tex",
                      disabled: _ctx.customSettings.name == 'Default'
                    }, null, 8, _hoisted_20), [
                      [_vModelRadio, _ctx.customSettings.tktTex]
                    ]),
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("editCustomSetting.tex")), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("editCustomSetting.allowance")), 1),
                _createElementVNode("output", _hoisted_24, _toDisplayString(_ctx.customSettings.defaultAllowance) + "%", 1),
                _withDirectives(_createElementVNode("input", {
                  type: "range",
                  class: "custom-range",
                  min: "0",
                  max: "50",
                  step: "1",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.customSettings.defaultAllowance) = $event)),
                  id: "customRange3",
                  disabled: _ctx.customSettings.name == 'Default'
                }, null, 8, _hoisted_25), [
                  [_vModelText, _ctx.customSettings.defaultAllowance]
                ])
              ]),
              (_ctx.customSettings.name != 'Default')
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        name: "inlineRadioOptions",
                        id: "inlineCheckBox3",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.customSettings.isDefaultSettingId) = $event)),
                        style: {"border":"1px solid black"}
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.customSettings.isDefaultSettingId]
                      ]),
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("editCustomSetting.setAsMyDefaultSetting")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_29, [
                (_ctx.customSettings.name != 'Default')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-sm btn-primary mt-2",
                      style: {"width":"7rem","border-radius":"4px"},
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.updateCustomSetting && _ctx.updateCustomSetting(...args)))
                    }, _toDisplayString(_ctx.$t("operationCreateComp.save")), 1))
                  : _createCommentVNode("", true),
                (_ctx.customSettings.name != 'Default')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-sm btn-secondary mt-2",
                      style: {"width":"8rem","border-radius":"4px","margin-left":"10px"},
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleDialogClose && _ctx.handleDialogClose(...args)))
                    }, _toDisplayString(_ctx.$t("operationCreateComp.cancel")), 1))
                  : _createCommentVNode("", true)
              ]),
              _cache[23] || (_cache[23] = _createElementVNode("hr", { style: {"width":"100%","text-align":"left","margin-left":"0","border-top":"2px solid rgba(0, 0, 0, 0.2)"} }, null, -1)),
              _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("editCustomSetting.stitchType")), 1),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_ComboBox, {
                    ref: "stitchData",
                    "data-source": _ctx.stitchTypeData,
                    height: 275,
                    maxlength: 30,
                    filter: 'contains',
                    placeholder: 'Select Stitch Type',
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setStitchComponentValue($event.sender._cascadedValue)))
                  }, null, 8, ["data-source"])
                ])
              ]),
              (_ctx.lastChnagedBy != '' && _ctx.showStitchData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.$t("editCustomSetting.lastChangedBy")) + " : " + _toDisplayString(_ctx.lastChnagedBy) + ", " + _toDisplayString(_ctx.$t("editCustomSetting.date")) + " : " + _toDisplayString(_ctx.lastchangedDate) + ", " + _toDisplayString(_ctx.$t("editCustomSetting.time")) + " : " + _toDisplayString(_ctx.lastChangedTime), 1))
                : _createCommentVNode("", true),
              (_ctx.showStitchData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("table", _hoisted_36, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            (_ctx.editStitchComponentData.rateRequired)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_37, [
                                  (_ctx.seamUnitDefaultValue == 'Imperial' && _ctx.editStitchComponentData.rateRequired)
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_38, _toDisplayString(_ctx.$t("styleGrid.stitch")) + "/Inch", 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.seamUnitDefaultValue == 'Metric' && _ctx.editStitchComponentData.rateRequired)
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_39, _toDisplayString(_ctx.$t("styleGrid.stitch")) + "/3CM", 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.editStitchComponentData.seamThiknessRequired)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_40, [
                                  (_ctx.editStitchComponentData.seamThiknessRequired)
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_41, _toDisplayString(_ctx.$t("operationListComp.seamThickness")) + "(mm)", 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("tr", null, [
                            (_ctx.editStitchComponentData.rateRequired)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_42, [
                                  (_ctx.editStitchComponentData.rateRequired)
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 0,
                                        class: "stitch",
                                        style: {"text-align":"right"},
                                        type: "number",
                                        min: "0",
                                        step: ".01",
                                        max: "50",
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editStitchComponentData.stdStitchRate) = $event)),
                                        disabled: _ctx.customSettings.name == 'Default',
                                        id: "stitchRate"
                                      }, null, 8, _hoisted_43)), [
                                        [_vModelText, _ctx.editStitchComponentData.stdStitchRate]
                                      ])
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.editStitchComponentData.seamThiknessRequired)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_44, [
                                  (_ctx.editStitchComponentData.seamThiknessRequired)
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 0,
                                        class: "stitch",
                                        style: {"text-align":"right"},
                                        type: "number",
                                        min: ".1",
                                        step: ".01",
                                        max: "999.99",
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editStitchComponentData.seamThikness) = $event)),
                                        disabled: _ctx.customSettings.name == 'Default',
                                        id: "seamThickness"
                                      }, null, 8, _hoisted_45)), [
                                        [_vModelText, _ctx.editStitchComponentData.seamThikness]
                                      ])
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("table", _hoisted_47, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            (_ctx.showBight)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_48, [
                                  (_ctx.seamUnitDefaultValue == 'Imperial' && _ctx.showBight)
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_49, _toDisplayString(_ctx.$t("editCustomSetting.bight")) + "(Inch)", 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.seamUnitDefaultValue == 'Metric' && _ctx.showBight)
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_50, _toDisplayString(_ctx.$t("editCustomSetting.bight")) + "(Cm)", 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", _hoisted_51, [
                              _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t("editCustomSetting.waste")) + "(%)", 1)
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            (_ctx.showBight)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_53, [
                                  (_ctx.showBight)
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 0,
                                        class: "stitch",
                                        style: {"text-align":"right"},
                                        step: ".01",
                                        type: "number",
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editStitchComponentData.defaultBight) = $event)),
                                        disabled: _ctx.customSettings.name == 'Default',
                                        id: "bight"
                                      }, null, 8, _hoisted_54)), [
                                        [_vModelText, _ctx.editStitchComponentData.defaultBight]
                                      ])
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", _hoisted_55, [
                              _withDirectives(_createElementVNode("input", {
                                class: "stitch",
                                style: {"text-align":"right"},
                                type: "number",
                                min: "0",
                                max: "999",
                                step: ".01",
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editStitchComponentData.defaultwaste) = $event)),
                                disabled: _ctx.customSettings.name == 'Default',
                                id: "defaultWaste"
                              }, null, 8, _hoisted_56), [
                                [_vModelText, _ctx.editStitchComponentData.defaultwaste]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showStitchData)
                ? (_openBlock(), _createElementBlock("hr", _hoisted_57))
                : _createCommentVNode("", true),
              (_ctx.needleData.length > 0 && _ctx.showStitchData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _createElementVNode("table", _hoisted_59, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_60, _toDisplayString(_ctx.$t("editCustomSetting.threadComponent")), 1),
                          _createElementVNode("th", _hoisted_61, _toDisplayString(_ctx.consumptionHeader), 1),
                          _cache[17] || (_cache[17] = _createElementVNode("th", {
                            scope: "col",
                            class: "op"
                          }, null, -1)),
                          _createElementVNode("th", _hoisted_62, _toDisplayString(_ctx.$t("editCustomSetting.wastageAdded")), 1),
                          _cache[18] || (_cache[18] = _createElementVNode("th", {
                            scope: "col",
                            class: "op"
                          }, null, -1)),
                          _createElementVNode("th", _hoisted_63, _toDisplayString(_ctx.$t("editCustomSetting.totalAfterWastage")), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.needleData, (item, id) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "item",
                            key: id
                          }, [
                            _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.needleData[id]), 1),
                            _createElementVNode("td", _hoisted_65, [
                              _withDirectives(_createElementVNode("input", {
                                class: "consumptionData",
                                type: "number",
                                min: "1",
                                max: "99999.9",
                                step: "0.01",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.consumptionValues[id]) = $event),
                                disabled: _ctx.customSettings.name == 'Default' || _ctx.needleData[id] === 'Gimp',
                                id: `consumptionData-${id}`,
                                "aria-label": `${_ctx.needleData[id]} consumption`
                              }, null, 8, _hoisted_66), [
                                [
                                  _vModelText,
                                  _ctx.consumptionValues[id],
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.lengthUnitLabel), 1)
                            ]),
                            _cache[19] || (_cache[19] = _createElementVNode("td", { class: "op" }, "+", -1)),
                            _createElementVNode("td", _hoisted_68, [
                              _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.wastageValues[id].toFixed(2)) + " " + _toDisplayString(_ctx.lengthUnitLabel), 1),
                              (_ctx.isAllowanceUsed)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(_ctx.$t("editCustomSetting.allowanceShort", { percentage: _ctx.effectiveWaste.toFixed(2) })), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _cache[20] || (_cache[20] = _createElementVNode("td", { class: "op" }, "=", -1)),
                            _createElementVNode("td", _hoisted_71, _toDisplayString(_ctx.totalValues[id].toFixed(2)) + " " + _toDisplayString(_ctx.lengthUnitLabel), 1)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("tfoot", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.totalsLabel), 1),
                          _createElementVNode("td", _hoisted_73, _toDisplayString(_ctx.consumptionTotal.toFixed(2)) + " " + _toDisplayString(_ctx.lengthUnitLabel), 1),
                          _cache[21] || (_cache[21] = _createElementVNode("td", { class: "op" }, null, -1)),
                          _createElementVNode("td", _hoisted_74, _toDisplayString(_ctx.wastageTotal.toFixed(2)) + " " + _toDisplayString(_ctx.lengthUnitLabel), 1),
                          _cache[22] || (_cache[22] = _createElementVNode("td", { class: "op" }, null, -1)),
                          _createElementVNode("td", _hoisted_75, _toDisplayString(_ctx.totalAfterWastageTotal.toFixed(2)) + " " + _toDisplayString(_ctx.lengthUnitLabel), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.$t("editCustomSetting.wastageFormulaNote", {
                      consumption: _ctx.consumptionHeader,
                      source: _ctx.wasteSourceLabel,
                      percentage: _ctx.effectiveWaste.toFixed(2)
                    })), 1),
                    (_ctx.isAllowanceUsed)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(_ctx.$t("editCustomSetting.allowanceUsedNote", { percentage: _ctx.effectiveWaste.toFixed(2) })), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("table", _hoisted_78, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_79, [
                              (_ctx.customSettings.name != 'Default')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-sm btn-primary mt-4",
                                    style: {"border-radius":"4px","width":"8em","margin-right":"5px"},
                                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.updateStitchData && _ctx.updateStitchData(...args)))
                                  }, _toDisplayString(_ctx.$t("editCustomSetting.update")), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}